import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotFound } from './404.component';
import { NotFoundRoutingModule } from './404-routing.module';
import { ButtonModule } from '../../components/atoms/button/button.module';
import { RouterModule } from '@angular/router';

export const routerConfig = [
  {
    path: '',
    component: NotFound,
  },
];
@NgModule({
  declarations: [NotFound],
  exports: [NotFound],
  imports: [
    CommonModule,
    NotFoundRoutingModule,
    ButtonModule,
    RouterModule.forChild(routerConfig),
  ],
})
export class NotFoundModule {}
